import { FC, createContext, Dispatch, SetStateAction, RefObject } from 'react';

import { WidgetType } from '../common/utils/widgetsUtils';
import { ContentObjectAdditionalAction } from '../types/ContentObjectAdditionalAction';
import { ManifestType } from '../types/ManifestType';

export const WidgetComponentContext = createContext<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getWidget: (
    widgetType: WidgetType,
    isStudioEdit: boolean,
    isPlenaryLessonStudent: boolean
  ) => {
    Component: FC<{
      className?: string;
      columnAmount?: number;
      columnGap?: number;
      desktopStageWidth?: number;
      isFirst?: boolean;
      setAdditionalActions?: Dispatch<SetStateAction<ContentObjectAdditionalAction[]>>;
      ref?: RefObject<any>;
      withScrollArea?: boolean;
      withPasteButton?: boolean;
      context?: 'regular' | 'split-screen-start' | 'split-screen-end';
      readOnly?: boolean;
    }>;
    Manifest?: ManifestType;
  };
} | null>(null);
